import { render, staticRenderFns } from "./AppChannelListSidebar.vue?vue&type=template&id=58f771bd&"
import script from "./AppChannelListSidebar.vue?vue&type=script&lang=js&"
export * from "./AppChannelListSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AppChannelListSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports